/* Small compatibility components. Commerce stays in Shrine 1.3.1's scripts. */
(() => {
  const define = (name, component) => {
    if (!customElements.get(name)) customElements.define(name, component);
  };
  define('internal-video', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.video = this.querySelector('video');
      if (!this.video) return;
      this.video.querySelectorAll('source[data-src]').forEach(source => {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      });
      this.video.load();
      const toggle = event => {
        event.preventDefault();
        if (this.video.paused) this.video.play().catch(() => {}); else this.video.pause();
      };
      this.querySelector('.internal-video__play')?.addEventListener('click', toggle);
      this.video.addEventListener('click', toggle);
      const update = () => {
        this.classList.toggle('internal-video--playing', !this.video.paused);
        this.classList.toggle('internal-video--muted', this.video.muted);
      };
      this.video.addEventListener('play', update);
      this.video.addEventListener('pause', update);
      this.video.addEventListener('volumechange', update);
      const sound = this.querySelector('.internal-video__sound-btn');
      sound?.setAttribute('aria-label', 'Toggle video sound');
      sound?.addEventListener('click', () => { this.video.muted = !this.video.muted; });
      const play = this.querySelector('.internal-video__play');
      play?.setAttribute('aria-label', 'Play or pause video');
      this.video.addEventListener('timeupdate', () => {
        const progress = this.querySelector('.internal-video__timeline');
        if (progress && this.video.duration) progress.style.setProperty('--progress', `${100*this.video.currentTime/this.video.duration}%`);
      });
      if (this.dataset.autoplay === 'true') {
        this.video.muted = true;
        this.observer = new IntersectionObserver(entries => {
          for (const entry of entries) {
            if (entry.isIntersecting) this.video.play().catch(() => {}); else this.video.pause();
          }
        });
        this.observer.observe(this);
      }
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
  define('modal-v2', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.dialog = this.querySelector('.modal-v2__modal');
      this.dialog?.setAttribute('role', 'dialog');
      this.dialog?.setAttribute('aria-modal', 'true');
      this.dialog?.setAttribute('aria-label', this.querySelector('.sizing-chart__title')?.textContent.trim() || 'Size chart');
      this.querySelectorAll('.modal-v2__open-btn').forEach(button => {
        button.type = 'button';
        button.addEventListener('click', () => this.show(true));
      });
      this.querySelectorAll('.modal-v2__close-btn').forEach(button => {
        if (button.tagName === 'BUTTON') { button.type = 'button'; button.setAttribute('aria-label', 'Close'); }
        button.addEventListener('click', () => this.show(false));
      });
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') this.show(false);
        if (event.key === 'Tab' && this.dataset.open === 'true') {
          const focusable = [...this.dialog.querySelectorAll('button,a[href],input,select,[tabindex="0"]')];
          const first = focusable[0], last = focusable.at(-1);
          if (event.shiftKey && document.activeElement === first) {event.preventDefault();last?.focus();}
          else if (!event.shiftKey && document.activeElement === last) {event.preventDefault();first?.focus();}
        }
      });
      this.show(this.dataset.open === 'true');
    }
    show(open) {
      this.dataset.open = String(open);
      this.classList.toggle('active', open);
      this.dialog?.setAttribute('aria-hidden', String(!open));
      this.querySelector('.modal-v2__open-btn')?.setAttribute('aria-expanded', String(open));
      if (open) this.dialog?.querySelector('button')?.focus();
      else if (this.wasOpen) this.querySelector('.modal-v2__open-btn')?.focus();
      this.wasOpen = open;
    }
  });
  define('dynamic-dates', class extends HTMLElement {
    connectedCallback() {
      const days = (this.dataset.dayLabels || '').split(',').map(x => x.trim());
      const months = (this.dataset.monthLabels || '').split(',').map(x => x.trim());
      const format = offset => {
        const date = new Date(); date.setDate(date.getDate() + (Number(offset) || 0));
        const day = days[date.getDay()] || date.toLocaleDateString(undefined,{weekday:'short'});
        const month = months[date.getMonth()] || date.toLocaleDateString(undefined,{month:'short'});
        const n = date.getDate();
        const pattern = this.dataset.dateFormat || 'day_dd_month';
        if (pattern.includes('mm_dd')) return `${date.getMonth()+1}/${n}`;
        if (pattern.includes('dd_mm')) return `${n}/${date.getMonth()+1}`;
        if (pattern.startsWith('month')) return `${month} ${n}`;
        return `${pattern.includes('day') ? day+' ' : ''}${n} ${month}`;
      };
      this.querySelectorAll('[data-dynamic-date]').forEach(item => {
        item.innerHTML = (item.dataset.text || '').replaceAll('[start_date]', format(item.dataset.minDays)).replaceAll('[end_date]', format(item.dataset.maxDays));
      });
    }
  });
  define('ep-cart-timer', class extends HTMLElement {
    connectedCallback() {
      const duration = Number(this.dataset.seconds) || 300;
      const key = 'ep-cart-timer-end';
      let end;
      try {
        end = Number(sessionStorage.getItem(key));
        if (!end) {end = Date.now()+duration*1000;sessionStorage.setItem(key,String(end));}
      } catch { end = Date.now()+duration*1000; }
      const tick = () => {
        const seconds = Math.max(0, Math.ceil((end-Date.now())/1000));
        this.textContent = `${Math.floor(seconds/60)}:${String(seconds%60).padStart(2,'0')}`;
      };
      tick(); this.timer = setInterval(tick,1000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
  });
  const showContent = root => root.querySelectorAll('.ep-legacy .animate--hidden').forEach(el => el.classList.add('animate--shown'));
  document.addEventListener('shopify:section:load', event => showContent(event.target));
  showContent(document);
})();
